import i18next from 'i18next';
import { ContattoEntity, DealerDTO } from 'src/api';

const clean = (value?: string | null): string =>
	(value ?? '').toString().replace(/\n/g, ' ').trim();

const formatBoolean = (value?: boolean): string =>
	value === undefined || value === null
		? ''
		: value
		? i18next.t('yes')
		: i18next.t('no');

const formatContatto = (contatto: ContattoEntity): string => {
	const nominativo = clean([contatto.nome, contatto.cognome].join(' '));
	const email = clean(contatto.email);
	const telefono = clean(contatto.telefono);
	const ruolo = clean(contatto.ruolo);

	return [
		nominativo,
		email && `<${email}>`,
		telefono && `— ${telefono}`,
		ruolo && `(${ruolo})`,
	]
		.filter(Boolean)
		.join(' ');
};

const formatContatti = (contatti?: ContattoEntity[]): string =>
	(contatti ?? []).map(formatContatto).filter(Boolean).join('; ');

export function buildDealersExportData(
	dealers: DealerDTO[]
): (string | number)[][] {
	const headers = [
		i18next.t('business_name'),
		i18next.t('membership_group'),
		i18next.t('address'),
		i18next.t('fiscal_code'),
		i18next.t('p_iva'),
		i18next.t('dealer_typology'),
		i18next.t('brand'),
		i18next.t('affiliated_rental_companies'),
		i18next.t('head_group'),
		i18next.t('sales_horizon'),
		i18next.t('backoffice_horizon'),
		i18next.t('referenti_dealer'),
		i18next.t('dealer_contacts'),
	];

	const rows = dealers
		.filter(Boolean)
		.map((dealer) => [
			clean(dealer.ragione_sociale).replace(/_/g, ' '),
			clean(dealer.group),
			clean(dealer.indirizzo),
			clean(dealer.cf),
			clean(dealer.p_iva),
			clean(dealer.tipologia_dealer),
			clean(dealer.marchio),
			clean(dealer.noleggiatori_convenzionati),
			formatBoolean(dealer.is_main_dealer),
			clean(dealer.id_sales),
			clean(dealer.id_backoffice),
			(dealer.referenti_dealer ?? []).map(clean).filter(Boolean).join(', '),
			formatContatti(dealer.contatti_list),
		]);

	return [headers, ...rows];
}
